import { render, staticRenderFns } from "./VehicleAssignments.vue?vue&type=template&id=2827ee06&scoped=true"
import script from "./VehicleAssignments.vue?vue&type=script&lang=js"
export * from "./VehicleAssignments.vue?vue&type=script&lang=js"
import style0 from "./VehicleAssignments.vue?vue&type=style&index=0&id=2827ee06&prod&scoped=true&lang=css"
import style1 from "./VehicleAssignments.vue?vue&type=style&index=1&id=2827ee06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827ee06",
  null
  
)

export default component.exports